import {Component, OnDestroy, OnInit} from '@angular/core';
import {EvidService} from "@catdetails/services/evid.service";
import {ExplorerItem, TreeNodeInfo} from "@catui/types";
import {ProjectService} from "@catcore/services";
import {Router} from "@angular/router";
import {Project} from "@catcore/types/api-v2";
import {isNullOrUndefined} from "util";

@Component({
  selector: 'catapp-evid',
  templateUrl: './evid.component.html',
  styleUrls: ['./evid.component.scss']
})
export class EvidComponent implements OnInit, OnDestroy {
  doAllowCreate = false;
  activeItem = false;
  explorerItems: ExplorerItem[] = [];
  subscription = null;

  constructor(private projectService: ProjectService,
              private router: Router,
              private evidService: EvidService) {
  }

  navigateTo(node: TreeNodeInfo) {
    this.router.navigate(node.item.value.route);
  }

  ngOnInit() {
    this.subscription = this.projectService
      .getCurrentProject()
      .subscribe((project: Project) => {
        if (!isNullOrUndefined(project)) {
          this.explorerItems = [];
          this.explorerItems.push(buildDefaultExplorerItem(project, 'Evid Functions', 'evid-functions'));
          this.explorerItems.push(buildDefaultExplorerItem(project, 'Debug', 'evid-debug'));
        }
      });
    this.evidService.setActive();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.evidService.setInactive();
  }
}

const buildDefaultExplorerItem = (project: Project, displayName: string, targetRef: string): ExplorerItem => {
  return {label: displayName, value: {route: ['projects', `${project.id}`, 'evid', targetRef]}, expanded: false, allowedActions: []};
};




// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project-details/components/evid/evid.component.ts